<style lang="scss"></style>
<style lang="scss" scoped="scoped"></style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;justify-content: space-between;">
    <div style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;">
      <span style="color: rgba(57, 241, 109, 1);font-weight: bold;font-size: 24px;">{{ $t('jinqirijianyanhege') }}:</span><span style="color: rgba(57, 241, 109, 1);font-weight: bold;font-size: 36px;">{{ count1 }}</span>
    </div>
    <div style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;margin-left: 20px;">
      <span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 24px;">{{ $t('jinqirijianyanbuhege') }}:</span><span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 36px;">{{ count2 }}</span>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_count',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      timer: null,
      count1: 0,
      count2: 0
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/web/report/page/yongxin_mes_zonghekanban_xuanjianjiankong_1', {
        params: {
          //orgId: this.$attrs.orgId,
        }
      });
      this.count1 = response.data.rows[0].v;
      this.count2 = response.data.rows[1].v;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 800);
    }
  }
};
</script>
